import React, { Component } from "react";
import numeral from "numeral";
import { isMobile } from "react-device-detect";

class ContentGridVanilla extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        path: this.props.tableName,
        payload: this.props.data
      }
    };
  }

  getImages = images => {
    try {
      //console.log("images Obj " + JSON.stringify(imgUrlsObj));

      if (images && images.length > 0) {
        //console.log("getting images");
        return images.map((image, index) => {
          //console.log("chota image: " + images.url);
          return (
            <a href={image.url} target="_blank">
              <div
                className="img"
                style={{
                  backgroundImage: "url('" + image.url + "')",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  border: "1px solid gainsboro",
                  maxWidth: "150px",
                  maxHeight: "75px"
                }}
              ></div>
            </a>
          );
        });
      }
    } catch (error) {
      return "";
    }
  };

  getCellValue = (strFormat, jsonValue, type) => {
    if (typeof jsonValue !== "object") {
      if (strFormat && strFormat === "numeral") {
        return <td align="right">{numeral(jsonValue).format("0,0.00")}</td>;
      } else {
        return jsonValue;
      }
    } else {
      //console.log("this is an object " + JSON.stringify(jsonValue));
      //let amt = "SGD " + numeral(props.quoteAmount).format("0,0.00");
      if (type === "photoUpload") {
        return (
          <td>
            <div className="images">{this.getImages(jsonValue)}</div>
          </td>
        );
      } else {
        return JSON.stringify(jsonValue);
      }
    }
  };

  getDivCellValue = (strFormat, jsonValue, type) => {
    if (typeof jsonValue !== "object") {
      if (strFormat && strFormat === "numeral") {
        return numeral(jsonValue).format("0,0.00");
      } else {
        return jsonValue;
      }
    } else {
      //console.log(type + " this is an object " + JSON.stringify(jsonValue));
      //let amt = "SGD " + numeral(props.quoteAmount).format("0,0.00");
      if (type === "photoUpload") {
        return <div className="images">{this.getImages(jsonValue)}</div>;
      } else {
        return JSON.stringify(jsonValue);
      }
    }
  };

  getColumns = (jObject, tableDef) => {
    //console.log(JSON.stringify(this.state))
    //console.log(JSON.stringify(tableDef));

    return Object.keys(tableDef).map((key, index) => {
      //console.log(key + "=" + tableDef[key]);
      if (key !== "searches") {
        if (index === 0) {
          return (
            <td
              data-title={tableDef[key].caption}
              style={{
                wordBreak: "break-word",
                wordWrap: "break-word",
                overflowWrap: "break-word"
              }}
            >
              <a
                href="#"
                onClick={() =>
                  this.props.handleEdit(
                    jObject.key,
                    this.props.tableName,
                    jObject
                  )
                }
              >
                {this.getCellValue(
                  tableDef[key].format,
                  jObject[key],
                  tableDef[key].type
                )}
              </a>
            </td>
          );
        } else {
          return (
            <td
              data-title={tableDef[key].caption}
              style={{
                wordBreak: "break-word",
                wordWrap: "break-word",
                overflowWrap: "break-word"
              }}
            >
              {this.getCellValue(
                tableDef[key].format,
                jObject[key],
                tableDef[key].type
              )}
            </td>
          );
        }
      }
    });
  };

  getDivColumns = (jObject, tableDef) => {
    //console.log("content grid issue: " + JSON.stringify(tableDef));
    return Object.keys(tableDef).map((key, index) => {
      //console.log("here is the " + key);
      if (key !== "searches") {
        return (
          <div>
            <span
              style={{
                marginLeft: "0px",
                color: "grey",
                fontSize: "12px",
                fontWeight: "bold"
              }}
            >
              {tableDef[key].caption}:
            </span>
            <span
              style={{
                wordBreak: "break-word",
                wordWrap: "break-word",
                overflowWrap: "break-word",
                fontSize: "15px",
                paddingLeft: "15px"
              }}
            >
              {this.getDivCellValue(
                tableDef[key].format,
                jObject[key],
                tableDef[key].type
              )}
            </span>
          </div>
        );
      }
    });
  };

  getHeaderRow = tableDef => {
    return Object.keys(tableDef).map(key => {
      if (key !== "searches" && tableDef[key]) {
        return <th>{tableDef[key].caption}</th>;
      }
    });
  };

  getRows = data => {
    return data.map(rec => {
      return <tr>{this.getColumns(rec, this.props.tableDef)}</tr>;
    });
  };

  getMobileDivs = data => {
    return data.map(rec => {
      return (
        <div
          onClick={() =>
            this.props.handleEdit(rec.key, this.props.tableName, rec)
          }
          style={{
            borderColor: "darkgray",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "10px",
            backgroundColor: "white",
            margin: "5px",
            padding: "5px",
            marginBottom: "15px",
            fontSize: "medium",
            fontWeight: "bold",
            boxShadow: "1px 2px #888888"
          }}
        >
          {this.getDivColumns(rec, this.props.tableDef)}
        </div>
      );
    });
  };

  render() {
    if (
      this.props.data &&
      this.props.data !== undefined &&
      this.props.data.length > 0
    ) {
      if (isMobile) {
        // console.log("it is mobile");
        return <div>{this.getMobileDivs(this.props.data)}</div>;
      } else {
        //console.log("it is not mobile");
        return (
          <div
            style={{
              scrollBehavior: "auto",
              borderColor: "yellow",
              borderWidth: "3px"
            }}
          >
            <table
              className={
                isMobile
                  ? "table table-striped table-sm"
                  : "table table-striped table-bordered table-lg"
              }
              style={{ tableLayout: "fixed" }}
            >
              <thead>
                <tr>{this.getHeaderRow(this.props.tableDef)}</tr>
              </thead>
              <tbody>{this.getRows(this.props.data)}</tbody>
            </table>
          </div>
        );
      }

      //return this.getRows(this.props.data);
    } else {
      //console.log("returning empty list");
      return <div style={{
        textAlign: 'center'
      }}>No items to display</div>;
    }
  }
}

export default ContentGridVanilla;



// WEBPACK FOOTER //
// ./src/app/components/Screens/ContentGrid/ContentGridVanilla.jsx